import { cn } from '../lib/utils';

import { Body } from './typography';

type LoadingStateProps = {
  message?: string;
  /** Extra classes on the wrapper — e.g. `min-h-screen` for a full-page loader. */
  className?: string;
};

/**
 * Loading indicator centered in its parent container. Fills the available space
 * (`size-full flex-1`) with a minimum height matching `EmptyState` (py-16), so it never
 * sticks to the top-left corner. Default message: `"Laden..."`. Use while data is fetching.
 */
export function LoadingState({ message = 'Laden...', className }: LoadingStateProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn('flex size-full flex-1 items-center justify-center px-6 py-16', className)}
    >
      <Body tone="muted">{message}</Body>
    </div>
  );
}

export type { LoadingStateProps };
